// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ae1f3dbe","769":"914b6c37"}[chunkId] + ".chunk.js";
};